import $ from 'jquery'
$(document).ready(function () {
    $('body').on('click', '.ltn__main-menu', function () {
         setTimeout(() => {
        //$('.vl-active').css('display', 'block');
        $('#modern_id').remove('ltn__header-transparent'),
            $('#modern_dId').addClass('ltn__header-middle-area ltn__header-sticky ltn__sticky-bg-white sticky-active')
        //setTimeout(() => {
        //    $('.vl-active').css('display', 'none');
        }
            , 4000);
    });

    //footer-nav
    $('body').on('click', '.footer-nav', function () {
        setTimeout(() => {
        $('#modern_id').remove('ltn__header-transparent'),
            $('#modern_dId').addClass('ltn__header-middle-area ltn__header-sticky ltn__sticky-bg-white sticky-active')
        }
            , 4000);
    });

    //site-logo site-logo-main

    $('body').on('click', '.site-logo,.site-logo-main,.ltn__breadcrumb-list', function () {
          setTimeout(() => {
        $('#modern_id').addClass('ltn__header-transparent'),
            $('#modern_dId').removeClass('sticky-active ltn__header-sticky ltn__sticky-bg-white')
        $('#modern_dId').addClass('ltn__header-middle-area ltn__header-sticky ltn__sticky-bg-black')
        }
            , 5000);
    });

    //ltn__breadcrumb-list

})














